import module from 'finanzas/module.js'
import template from './template.html'

const getMonto = (item) => item.replace(/[^\d.-]/g, '').replace(/^([^.]*\.)(.*)$/, (a, b, c) => b + c.replace(/\./g, ''))

class FinanzasClasificarmovimientosMasivoListaMatchComponent {
  constructor (FinanzasClasificarMovimientos, $notify) {
    this.FinanzasClasificarMovimientos = FinanzasClasificarMovimientos
    this.$notify = $notify
    this.data = null
    this.doMatch = null
    this.textopdf = ''
  }

  buscarCoincidencias () {
    try {
      let texto = this.textopdf.trim()
      let array = texto.split('\n')
      let renglon, datos = []

      array.forEach(function (elemento) {
        renglon = elemento.split(' ')
        datos.push({
          'deposito': renglon[2].trim() !== '$' ? parseFloat(getMonto(renglon[2])) : parseFloat(getMonto(renglon[3])),
          'cuenta': renglon[1],
        })
      })
      this.doMatch({$event: {data: datos}})
    } catch ($e) {
      this.$notify.error('El texto no puede ser decifrado')
    }
  }
}

module.component('finanzasClasificarmovimientosMasivoListaMatch', {
  controller: FinanzasClasificarmovimientosMasivoListaMatchComponent,
  template,
  bindings: {
    data: '<',
    doMatch: '&',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/_/clasificarmovimientos/components/masivo/lista/match/component.js